
    import Vue from "vue";
    import FileUploader from "@/components/FileUploader.vue";
    import Component from "vue-class-component";
    import SectionPageHeading from "@/features/shared/components/sections/SectionPageHeading.vue";
    import HeadingWave from "@/features/shared/components/HeadingWave.vue";
    import HeadingGroup from "@/features/shared/components/HeadingGroup.vue";
    import DatePicker from "@/components/DatePicker.vue";
    import {
        AddSeafarerWithoutPersonalCodeModel,
        CountryLightModel,
        DocumentAttributesClient,
        factory,
        Gender,
        ResultError,
        SeafarersClient
    } from "@/api-client";
    import {Prop} from "vue-property-decorator";
    import Loader from "@/features/shared/components/Loader";
    import userInfo from "@/features/shared/components/UserInfo";
    import {authService} from "@/AuthService";
    import PopoverInfo from '@/components/PopoverInfo.vue';
    import {NavigationGuardNext} from "vue-router/types/router";

    interface Props {
        countries: CountryLightModel[];
    }

    @Component({
        components: {
            SectionPageHeading,
            HeadingWave,
            FileUploader,
            HeadingGroup,
            PopoverInfo,
            DatePicker
        },
        beforeRouteEnter(to, from, next: NavigationGuardNext<CreateSeafarerProfile>) {
            const props = to.meta!.props as Props;
            Promise.all([
                new DocumentAttributesClient().countries()
            ]).then(values => {
                props.countries = values[0];
                next();
            }).catch(e => next(e))
        }
    })
    export default class CreateSeafarerProfile extends Vue implements Props {
        @Prop({required: true})
        countries!: CountryLightModel[];

        model = factory.create(AddSeafarerWithoutPersonalCodeModel);
        validationErrors = ResultError.createEmpty();
        loader = new Loader();
        fileLoader = new Loader();

        created(){
            this.model.email = userInfo.userName;
            this.model.firstName = userInfo.firstName;
            this.model.lastName = userInfo.lastName;

            this.$watch(() => this.model.withoutNationality, () => {
                this.model.nationality = null;
            });
        }

        async createProfile(){
            this.validationErrors = ResultError.createEmpty();
            await new SeafarersClient().setLoader(this.loader).createProfile(this.model)
                .then(async (result) => {
                    await authService.refreshProfiles();
                    await authService.selectProfile(authService.availableProfiles.filter(p => p.isSeafarer)[0])
                    await this.$router.push({ name: 'person-profile', params: { seafarerId: result.id } });
                })
                .catch(error => this.setValidationErrors(error, this.$ls.Seafarers_Toast_ProfileCreationFailure));
        }

        genderOptions = [
            {text: this.$ls.Global_Gender_Male, value: Gender.Male},
            {text: this.$ls.Global_Gender_Female, value: Gender.Female},
        ];
    }
